// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api/axios'
// import qs from 'qs'//qs.parse()url参数转对象  qs.stringify()对象转url参数
import store from './store'
import common from './api/common'
import MintUi from 'mint-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import '../static/css/common.css'
import '../static/js/flexble.js'
import 'mint-ui/lib/style.css'
import { Indicator, Toast, MessageBox , Switch } from 'mint-ui'
import './assets/iconfont/iconfont.css'
import echarts from 'echarts'
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.component(Switch.name, Switch);


Vue.prototype.$toast = Toast;
Vue.prototype.$echarts = echarts
Vue.prototype.$http = axios
Vue.prototype.$common = common
Vue.use(MintUi)
Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */

/**********
 * 全局自定义指令
 * *******/
Vue.filter('formatDate', function(dateStr) {
  if (dateStr === null || dateStr === 'null') {
    return ''
  } else {
    var now = new Date(dateStr)
    var year = now.getFullYear(),
      month = now.getMonth() + 1,
      date = now.getDate(),
      hour = now.getHours(),
      minute = now.getMinutes(),
      second = now.getSeconds()
    month = month < 10 ? '0' + month : month
    date = date < 10 ? '0' + date : date
    hour = hour < 10 ? '0' + hour : hour
    minute = minute < 10 ? '0' + minute : minute
    second = second < 10 ? '0' + second : second
    return (
      year + '/' + month + '/' + date + ' ' + hour + ':' + minute + ':' + second
    )
  }
})
Vue.filter('formatDateExp', function(dateStr, format) {
  if (dateStr === null || dateStr === 'null') {
    return ''
  }
  var date = new Date(dateStr)
  if (!format) format = 'yyyy-MM-dd hh:mm:ss'
  var millisecond = date.getMilliseconds()
  if (millisecond < 10) {
    millisecond = '00' + millisecond
  } else if (millisecond < 100) {
    millisecond = '0' + millisecond
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S+': millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return format
})

Vue.filter('levelText', function(levelNum) {
  var levelText = [
    '预备代理',
    '正式代理',
    '铜牌代理',
    '银牌代理',
    '金牌代理',
    '钻石代理',
    '星耀代理'
  ][levelNum]
  return levelText
})
/********
 * 实例化vue
 * *******/
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

  //检查登录状态
  created() {
    //钩子函数
    this.setHomeTitle()
    this.checkLogin()
  },
  methods: {
    setHomeTitle() {
      var that = this
      var hosts = window.location.host
      var homeTitle = ''
      switch (hosts) {
        case 'js3mj-manager.shrongyikeji.com':
          homeTitle = '闲云-江苏'
          break
        case 'xuzhou-manager.shrongyikeji.com':
          homeTitle = '闲云-徐州'
          break
        case 'huaian-manager.shrongyikeji.com':
          homeTitle = '闲云-淮安'
          break
        case 'haian-manager.shrongyikeji.com':
          homeTitle = '闲云-海安'
          break
        case 'yongzhou-manager.shrongyikeji.com':
          homeTitle = '闲云-永州'
          break
        case 'yueyang-manager.shrongyikeji.com':
          homeTitle = '海安'
          break
        case 'hubei-manager.shrongyikeji.com':
          homeTitle = '闲云-湖北'
          break
        case 'leiyang-manager.shrongyikeji.com':
          homeTitle = '闲云-耒阳'
          break
        case 'shaoyang-manager.shrongyikeji.com':
          homeTitle = '天天2棋牌'
          break
        case 'jinzhong-manager.shrongyikeji.com':
          homeTitle = '天星-山西'
          break
        case 'hengyang-manager.shrongyikeji.com':
          homeTitle = '北斗-衡阳'
          break
        case 'xiangxiang-manager.shrongyikeji.com':
          homeTitle = '北斗棋牌'
          break
        case 'shanxi-manager.shrongyikeji.com':
          homeTitle = '兜趣山西'
          break
        default:
          homeTitle = '闲云-江苏'
          break
      }
      that.$store.commit('setHomeTitle', homeTitle)
    },
    checkLogin() {
      //页面开始渲染 先走这里
      if (localStorage.code == 9999) {
        localStorage.clear()
        router.push('/login')
      } else {
        router.push('/home')
      }
    }
  }
})

/*******
 * 全局路由钩子 跳转路由前触发
 * *****/
router.beforeEach((to, from, next) => {
  if (from.name == 'memberApply') {
    store.dispatch('getUserMsg') //获取新的申请代理红点提示
  }
  store.commit('changeLoading', false)
  if (to.meta.title) {
    store.commit('saveTitle', to.meta.title)
  }
  if (to.query.managerId) {
    store.commit('saveTitle', '商务' + to.query.managerId + '的代理')
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js